import {setCheckOrderPassengers, setPassengerDataUpdating, setTicket} from "@CheckOrder/reducers/checkOrderSlice";
import consolidatePassengers from "@CheckOrder/api/functions/consolidatePassengers";
import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {
    RemoveActiveAddonRequestType,
    RemoveActiveAddonResponseType
} from "@CheckOrder/api/types/RemoveActiveAddonQuery.type";
import {setError} from "@Reducers/pageSlice";

export default function removeAddonQuery(): OnQueryStartedFunctionAttrType<RemoveActiveAddonRequestType, RemoveActiveAddonResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        dispatch(setPassengerDataUpdating(true))

        try {
            const response = await queryFulfilled

            if (response.meta.response.ok) {
                const passengers = consolidatePassengers(
                    request.passengers,
                    response.data.checkOrder.passengers
                )

                dispatch(setTicket({ticket: response.data.checkOrder.ticket, keepPassengerClasses: true}))
                dispatch(setCheckOrderPassengers(passengers))
                dispatch(setPassengerDataUpdating(false))
            }
        } catch (err) {
            dispatch(setError({
                error: "Failed to remove an addon",
                info: `ticket: ${request.ticketCode}, vehicle: ${request.passengerId}`,
            }))
        }
    }
}